  function getSave(){
    let moneyFormat = null;
    let comparePrice = 0
    setTimeout(()=>{
      $(".cart-item").each((idx,el)=>{
        moneyFormat = $(el).attr("data-money-format")
        comparePrice = Number($(el).attr("data-compare-price")) + comparePrice
      })
    if(moneyFormat&&comparePrice){
      $(".totals .save_price").show()
     $(".totals .save_price").text(moneyFormat.replace("{{amount_no_decimals}}",(comparePrice/100).toFixed(2)))
    }else{
      $(".totals .save_price").hide()
    }
     
    },0)
  }
  
  window.onload=getSave;
document.addEventListener('cart::drawer::open',getSave);
  document.addEventListener('drawer:menu:open',getSave);
  document.addEventListener('custom_cart_change',getSave);
  document.addEventListener('cart:swiper:update',getSave);